import { numberUtils } from '@origin-digital/utils-toolbox';

export const POSTCODE_VALIDATION_RULES = [
  {
    validate: (value) => {
      return (value && value !== '') || false;
    },
    errorMessage: 'Please enter your postcode',
  },
  {
    validate: (value) => {
      return value.length === 4;
    },
    errorMessage: 'Postcode must be 4 digits',
  },
  {
    validate: (value) => {
      return numberUtils.onlyContainsDigits(value);
    },
    errorMessage: 'Postcode must be 4 digits',
  },
];

export const ELECTRICITY_UNIT_VALIDATION_RULES = [
  {
    validate: (value) => {
      return (value && value !== '') || false;
    },
    errorMessage: 'Please enter an electricity value',
  },
  {
    validate: (value) => {
      return value.length > 0 && value.length < 5;
    },
    errorMessage: 'Electricity value must be between 1 and 4 digits',
  },
  {
    validate: (value) => {
      return numberUtils.onlyContainsDigits(value);
    },
    errorMessage: 'Electricity value must be digits only',
  },
];

export const GAS_UNIT_VALIDATION_RULES = [
  {
    validate: (value) => {
      return (value && value !== '') || false;
    },
    errorMessage: 'Please enter a gas value',
  },
  {
    validate: (value) => {
      return value.length > 0 && value.length < 6;
    },
    errorMessage: 'Gas value must be between 1 and 5 digits',
  },
  {
    validate: (value) => {
      return numberUtils.onlyContainsDigits(value);
    },
    errorMessage: 'Gas value must be digits only',
  },
];

export function getValidationError(fieldValue, rules) {
  let validationError = '';
  const l = rules.length;
  for (let i = 0; i < l; i++) {
    if (rules[i].validate(fieldValue) === false) {
      validationError = rules[i].errorMessage;
      break;
    }
  }
  return validationError;
}
